"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var RuleEditorText = function RuleEditorText(_ref) {
  var atom = _ref.atom,
      value = _ref.value,
      setValue = _ref.setValue;
  return /*#__PURE__*/_react.default.createElement(_antd.Input, {
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    value: value || atom.default
  });
};

var _default = RuleEditorText;
exports.default = _default;